import OverlayTrigger, {
  OverlayTriggerRenderProps
} from 'react-bootstrap/OverlayTrigger';
import { Placement } from 'react-bootstrap/types';

import { Tooltip } from 'react-bootstrap';
import classes from './PopoverHover.module.scss';

type Props = {
  children:
  | React.ReactElement
  | ((props: OverlayTriggerRenderProps) => React.ReactNode);
  placement?: Placement;
  message: string | undefined;
};

export const PopoverHover = ({ message, placement = 'bottom', children }: Props) => (
  <OverlayTrigger
    placement={placement}
    delay={{ show: 150, hide: 100 }}
    overlay={
      <Tooltip className={classes['um-popover-tooltip-container']}>{message}</Tooltip>
    }
  >
    {children}
  </OverlayTrigger>
);
